export class FlightDate {
    start: {
        year: number, 
        month: number, 
        day: number
    };
    end: {
        year: number, 
        month: number, 
        day: number
    };
    percent:number;
    targetBudget: number;
    constructor (data){
        this.start = data.start;
        this.end = data.end;
        this.targetBudget = data.targetBudget;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/expense/flight-date.ts